import BaseStore from '../Base.js'
import {Actions} from './Constants'
import {AuthConstants} from '../auth'

import _ from 'lodash'

class TokenStore extends BaseStore {
   constructor() {
      super()

      this.subscribe(this._subscribe.bind(this))
      this._tokens = null
      this._sessions = null
   }

   _subscribe(action) {
      switch (action.actionType) {
         case AuthConstants.Actions.logout:
            this._tokens = this._sessions = null
            this.emitChange()
            break

         case Actions.create:
            switch (action.token.type) {
               case 'session':
                  if (null === this._sessions) {
                     this._sessions = []
                  }

                  this._sessions.push(action.token)

                  this.emitChange()
                  break

               case 'token':
                  if (null === this._tokens) {
                     this._tokens = []
                  }

                  this._tokens.push(action.token)

                  this.emitChange()
                  break

               default:
                  break
            }

            this.emitChange()
            break

         case Actions.revoke:
            let idx = _.findIndex(this._sessions, e => e.fingerprint === action.fingerprint)

            if (-1 !== idx) {
               this._sessions[idx].revoked = {at: new Date().toISOString(), reasons: action.reason}
               this.emitChange()
            } else if (
               -1 !== (idx = _.findIndex(this._tokens, e => e.fingerprint === action.fingerprint))
            ) {
               this._tokens[idx].revoked = {at: new Date().toISOString(), reasons: action.reason}
               this.emitChange()
            }
            break

         case Actions.fetch_tokens:
            this._tokens = action.tokens
            this.emitChange()
            break

         case Actions.fetch_sessions:
            this._sessions = action.sessions
            this.emitChange()
            break

         default:
            break
      }
   }

   get tokens() {
      return this._tokens
   }

   get sessions() {
      return this._sessions
   }
}

export default new TokenStore()



// WEBPACK FOOTER //
// lib/api/tokens/Store.js